/* eslint-disable no-unused-vars */
import { useKit } from 'models/kits';
import ZoomInIcon from '@material-ui/icons/ZoomIn';
import React, { useEffect, useState } from 'react';
import 'react-medium-image-zoom/dist/styles.css';
import { Controlled as ControlledZoom } from 'react-medium-image-zoom';
import useAPI from 'hooks/api-hooks';
import { useQuery } from 'react-query';
import { LoaderSkeleton } from 'components/layout/KitRegistrationDashboard';
import CircularProgress from '@material-ui/core/CircularProgress';
import { useTranslation } from 'react-i18next';
import Alert from '@material-ui/lab/Alert';
import AlertTitle from '@material-ui/lab/AlertTitle';
import { makeStyles } from '@material-ui/core/styles';
import { InputLabel, FormControl, Select, MenuItem, Typography, TextField, Button, Grid } from '@material-ui/core';
import { langTypeToText } from 'components/app/LangSwitcher';
import { UserGroups, useAuth } from 'AuthCtx';
// import { useFormRules, useInputValidation } from 'hooks/form-rules';
import FormSection from './atoms/FormSection';
import FormSectionSubmit from './atoms/FormSectionSubmit';
import { userGroupToColor } from './SignUpForm';
// import SimpleInputField from './atoms/SimpleInputField';

const useStyles = makeStyles((theme) => {
  return {
    patientColor: {
      '& .MuiOutlinedInput-notchedOutline': {
        borderColor: userGroupToColor[UserGroups.Patient],
      },
      '& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline': {
        borderColor: userGroupToColor[UserGroups.Patient],
      },
      '&.checked': {
        color: userGroupToColor[UserGroups.Patient],
      },
      '& .MuiPickersDay-root': {
        '&.Mui-selected': {
          backgroundColor: userGroupToColor[UserGroups.Patient],
        },
      },
      borderColor: userGroupToColor[UserGroups.Patient],
      '& .MuiOutlinedInput-root': {
        '& fieldset': {
          borderColor: userGroupToColor[UserGroups.Patient],
        },
        '&:hover fieldset': {
          borderColor: userGroupToColor[UserGroups.Patient],
        },
        '&.Mui-focused fieldset': {
          borderColor: userGroupToColor[UserGroups.Patient],
        },
      },
    },
    doctorColor: {
      '& .MuiOutlinedInput-notchedOutline': {
        borderColor: userGroupToColor[UserGroups.Doctor],
      },
      '& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline': {
        borderColor: userGroupToColor[UserGroups.Doctor],
      },
      '&.checked': {
        color: userGroupToColor[UserGroups.Doctor],
      },
      '& .MuiPickersDay-root': {
        '&.Mui-selected': {
          backgroundColor: userGroupToColor[UserGroups.Doctor],
        },
      },
      borderColor: userGroupToColor[UserGroups.Doctor],
      '& .MuiOutlinedInput-root': {
        '& fieldset': {
          borderColor: userGroupToColor[UserGroups.Doctor],
        },
        '&:hover fieldset': {
          borderColor: userGroupToColor[UserGroups.Doctor],
        },
        '&.Mui-focused fieldset': {
          borderColor: userGroupToColor[UserGroups.Doctor],
        },
      },
    },
    corporateColor: {
      '& .MuiOutlinedInput-notchedOutline': {
        borderColor: userGroupToColor[UserGroups.Corporate],
      },
      '& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline': {
        borderColor: userGroupToColor[UserGroups.Corporate],
      },
      '&.checked': {
        color: userGroupToColor[UserGroups.Corporate],
      },
      '& .MuiPickersDay-root': {
        '&.Mui-selected': {
          backgroundColor: userGroupToColor[UserGroups.Corporate],
        },
      },
      borderColor: userGroupToColor[UserGroups.Corporate],
      '& .MuiOutlinedInput-root': {
        '& fieldset': {
          borderColor: userGroupToColor[UserGroups.Corporate],
        },
        '&:hover fieldset': {
          borderColor: userGroupToColor[UserGroups.Corporate],
        },
        '&.Mui-focused fieldset': {
          borderColor: userGroupToColor[UserGroups.Corporate],
        },
      },
    },
    alert: {
      display: 'flex',
      alignItems: 'center',
      marginBottom: '10px',
      flexWrap: 'nowrap',
      '& .MuiAlert-icon': {
        fontSize: 30,
      },
      [theme.breakpoints.down('xs')]: {
        flexWrap: 'wrap',
      },
    },
  };
});

const SelectReportLanguageForm = (
  {
    kitId,
    onSubmit,
    onError,
    href,
  },
) => {
  const { client } = useAPI();
  const {
    data: locales,
    isLoading,
  } = useQuery(
    [ 'locales' ],
    () => {
      return client.get('locales');
    },
  );

  const [ isSubmitting, setSubmitting ] = useState(false);
  const classes = useStyles();
  const { t, i18n } = useTranslation();

  const [ referenceNumber, setReferenceNumber ] = useState('');
  const [ referenceResponse, setReferenceResponse ] = useState({});
  const [ referenceNumberErrorText, setReferenceNumberErrorText ] = useState('');
  const [ referenceNumberExampleZoomedIn, setReferenceNumberExampleZoomedIn ] = useState(false);

  useEffect(() => {
    if ('' !== referenceNumber && 13 !== referenceNumber?.length) {
      setReferenceNumberErrorText('Ο αριθμός παραστατικού θα πρέπει να αποτελείται από 13 ψηφία.');
    } else {
      setReferenceNumberErrorText('');
    }
  }, [ referenceNumber ]);

  const { locale, updateLocale, isLoading: isKitLoading, isKitPGX, kitMetadata, updateKitMetadata, child, data } = useKit(kitId);

  const [ amka, setAmka ] = useState('');
  const [ errorAMKA, setErrorAMKA ] = useState(false);

  const initialAmka = (null != data?.customer_id?.social_security_number) ? data?.customer_id?.social_security_number : '';

  useEffect(() => {
    setAmka(initialAmka);
  }, [ initialAmka ]);

  const [ newLocale, setNewLocale ] = useState(undefined);
  const [ referentialError, setReferentialError ] = useState(false);
  const [ eopyyLoading, setEopyyLoading ] = useState(false);
  const [ availableLocales, setAvailableLocales ] = useState([]);

  // the request to get the EOPYY data
  const referentalRequest = async (value) => {
    setEopyyLoading(true);
    setReferenceResponse({});
    const response = await client.get(`/registration-kits/eopyy/getPrescriptionInfo/${ value }`);
    if (undefined === response?.patient?.amka || null === response?.patient?.amka) {
      setReferentialError(true);
      setReferenceResponse({});
    } else {
      setReferentialError(false);
      setReferenceResponse(response);
    }
    setEopyyLoading(false);
  };

  useEffect(() => {
    if (null != kitMetadata && null !== kitMetadata?.referenceNumber && '' === referenceNumber) {
      setReferenceNumber(kitMetadata.referenceNumber);
    }
  }, [ kitMetadata ]);

  useEffect(() => {
    if (null != kitMetadata && undefined !== kitMetadata?.referenceNumber && null !== kitMetadata?.referenceNumber
      && '' === referenceNumber && 13 === kitMetadata?.referenceNumber.length) {
      referentalRequest(kitMetadata.referenceNumber);
    } else {
      setReferenceResponse({});
    }
  }, [ ]);

  useEffect(() => {
    if (null == locales) { return; }
    setAvailableLocales(locales);
  }, [ locales ]);

  const { isDoctor, isCorporate } = useAuth();

  useEffect(() => {
    if (!isKitLoading && null != locale && newLocale === undefined) {
      setNewLocale(locale);
    } else if (!isLoading && null != availableLocales && newLocale === undefined && null === locale) {
      const foundLocale = availableLocales.find((loc) => { return loc.name === i18n.language; }) ?? availableLocales[0];
      if (foundLocale !== undefined) {
        setNewLocale(foundLocale.id);
      }
    }
  }, [ isLoading, availableLocales, isKitLoading, locale ]);

  const handleReferential = (e) => {
    const { value } = e.target;
    setReferenceNumber(value);
    if (13 !== value.length) {
      setReferenceResponse({});
    }
    referentalRequest(value);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    const metadata = { referenceNumber };
    setReferentialError(false);
    updateKitMetadata({ metadata }).then(() => {
      updateLocale({ newLocale }).then(() => {
        setSubmitting(false);
        onSubmit();
      });
    });
  };

  if (isLoading || newLocale === undefined) {
    return <LoaderSkeleton />;
  }

  return (
    <form
      noValidate
      onSubmit={ handleSubmit }
    >

      {isKitPGX && false && isCorporate && (
        <FormSection label={ t('reg_kit.select_report_locale.pgx.referral_registration') }>
          <Grid container spacing={ 1 }>
            <Grid item lg={ 8 } xs={ 12 }>

              <Typography variant='subtitle1'>
                {
                  (isDoctor || isCorporate) ? (
                    <>
                      {t('referential_part1') }
                    </>
                  )
                    : (
                      <>
                        {t('reg_kit.select_report_locale.adult.pgx.have_referral_part1') }
                      </>
                    )
                }
              </Typography>

              <Typography variant='subtitle1' style={ { marginBottom: '30px' } }>
                {t('reg_kit.select_report_locale.pgx.have_referral_part2')}
              </Typography>

              <Typography
                variant='body2'
                style={ { marginBottom: '10px',
                  display: 'flex',
                  alignItems: 'center' } }
              >
                {t('reg_kit.select_report_locale.pgx.enter_referral_num')}
              </Typography>

              <TextField
                fullWidth
                variant='outlined'
                onWheel={ (e) => { return e.target.blur(); } }
                value={ referenceNumber }
                onChange={ (e) => { handleReferential(e); } }
                label={ t('common.referral_num') }
                color='secondary'
                helperText={ t(referenceNumberErrorText) }
                type='number'
                error={ '' !== referenceNumberErrorText }
                style={ { maxWidth: '388px' } }
              />
              {eopyyLoading && 13 === referenceNumber.length && (
                <div style={ { textAlign: 'center', padding: '10px' } }><CircularProgress /></div>
              )}
              {referentialError && 13 === referenceNumber.length && !eopyyLoading && (
                <div style={ { padding: '10px' } }>
                  <Alert
                    severity='warning'
                    className={ classes.alert }
                  >
                    <AlertTitle
                      style={ { fontWeight: 'bold' } }
                    >
                      {t('Ο αριθμός παραστατικού δεν είναι σωστός.')}
                    </AlertTitle>
                  </Alert>
                </div>
              )}
              {referenceResponse?.patient?.amka !== undefined && null !== referenceResponse?.patient?.amka && (
                <div style={ { padding: '10px', fontWeight: 500 } }>
                  <div>
                    <b>{t('patientFirstName')}</b>
                    {': '}
                    {referenceResponse?.patient?.firstname}
                    <br />
                    <b>{t('patientLastName')}</b>
                    {': '}
                    {referenceResponse?.patient?.lastname}
                  </div>
                  <div>
                    <b>AMKA:</b>
                    {' '}
                    {referenceResponse?.patient?.amka}
                  </div>
                  <div>
                    <b>AMA:</b>
                    {' '}
                    {referenceResponse?.patient?.ama}
                  </div>
                  <div>
                    <b>{t('doctorHealthProfessional')}</b>
                    {': '}
                    {referenceResponse?.doctor?.firstname}
                    {' '}
                    {referenceResponse?.doctor?.lastname}
                    <br />
                    <b>
                      {t('doctorsAMKA')}
                      {' '}
                      :
                      {' '}
                    </b>
                    {referenceResponse?.doctor?.amka}
                    <br />
                    <b>
                      {t('Ημερομηνία έκδοση συνταγής')}
                      {' '}
                      :
                      {' '}
                    </b>
                    {referenceResponse?.meta?.issueDate}

                  </div>
                </div>
              )}
            </Grid>

            <Grid item xs={ 12 } lg={ 4 }>
              <div style={ { display: 'flex',
                flexDirection: 'column',
                background: '#F2F0F1',
                padding: '10px',
                borderRadius: '5px' } }
              >
                <Typography
                  variant='body2'
                  style={ { fontWeight: 'bold',
                    color: '#888781',
                    marginBottom: '8px' } }
                >
                  {t('reg_kit.select_report_locale.pgx.referral_sample')}
                </Typography>

                <Typography variant='body2' style={ { color: '#888781', marginBottom: '8px' } }>
                  {t('reg_kit.select_report_locale.pgx.view_referral_sample')}
                </Typography>
                <ControlledZoom
                  isZoomed={ referenceNumberExampleZoomedIn }
                  onZoomChange={ (e) => {
                    setReferenceNumberExampleZoomedIn(e);
                  } }
                >
                  <img
                    src='ReferenceNumberExample.png'
                    alt='Reference Number Example'
                    style={ { width: '100%', height: 'auto' } }
                  />

                </ControlledZoom>

                <Button
                  variant='contained'
                  fullWidth
                  startIcon={ <ZoomInIcon /> }
                  onClick={ () => { setReferenceNumberExampleZoomedIn(true); } }
                  style={ { color: '#50A2DD' } }
                >
                  {t('reg_kit.select_report_locale.pgx.zoom_in')}
                </Button>
              </div>
            </Grid>

            {
              isKitPGX && false && (
                <Grid
                  item
                  xs={ 12 }
                >
                  <FormSection
                    label={ t('reg_kit.select_report_locale.pgx.amka_registration') }
                    style={ { marginBottom: 0 } }
                  >
                    <TextField
                      fullWidth
                      variant='outlined'
                      value={ amka }
                      onChange={ (e) => {
                        if (11 === e.target.value.length) {
                          setErrorAMKA(false);
                        }
                        setAmka(e.target.value);
                      } }
                      required
                      label={ t('common.amka') }
                      color='secondary'
                      helperText={ errorAMKA && t('validation.elevenChars') }
                      type='number'
                      error={ errorAMKA }
                      style={ { maxWidth: '388px' } }
                    />
                  </FormSection>
                </Grid>
              )
            }
          </Grid>

        </FormSection>
      )}

      <FormSection label={ t('reg_kit.select_report_locale.common.header') }>
        <Typography variant='subtitle1' style={ { marginBottom: '30px' } }>
          {
            null != child
              ? t('reg_kit.select_report_locale.child.select_lang_desc')
              : (isDoctor || isCorporate) ? isKitPGX ? t('reg_kit.select_report_locale.doctor.pgx.select_lang_desc') : t('reg_kit.select_report_locale.doctor.non_pgx.select_lang_desc')
                : t('reg_kit.select_report_locale.adult.select_lang_desc')
          }
        </Typography>

        <Alert
          severity='warning'
          className={ classes.alert }
        >
          <AlertTitle
            style={ { fontWeight: 'bold' } }
          >
            {t('reg_kit.select_report_locale.common.cant_change_language')}
          </AlertTitle>
        </Alert>

        <FormControl variant='outlined' fullWidth style={ { maxWidth: '300px' } } color='secondary'>
          <InputLabel id='demo-simple-select-outlined-label-locale'>{t('reg_kit.select_report_locale.common.available_languages')}</InputLabel>
          <Select
            className={ isDoctor ? classes.doctorColor : isCorporate ? classes.corporateColor : classes.patientColor }
            labelId='demo-simple-select-outlined-label-locale'
            value={ newLocale }
            onChange={ (e) => {
              setNewLocale(e.target.value);
              i18n.changeLanguage(langTypeToText[e.target.value]);
            } }
            label={ t('reg_kit.select_report_locale.common.available_languages') }
          >
            {availableLocales?.map((v) => {
              return (
                <MenuItem key={ v.id } value={ v.id }>
                  <img
                    style={ { marginRight: '10px' } }
                    src={ langTypeToText[v.name]?.icon }
                    alt={ langTypeToText[v.name]?.name }
                  />
                  {t(langTypeToText[v.name].name)}
                </MenuItem>
              );
            })}
          </Select>
        </FormControl>

      </FormSection>

      <FormSectionSubmit
        label={ t('common.save') }
        loading={ isSubmitting }
        color={ isDoctor ? '#526D9C' : undefined }
      />
    </form>
  );
};

export default SelectReportLanguageForm;
